import { numberToPrettyString } from '@cian/utils';

import { selectFullPriceByOfferId } from './selectFullPriceByOfferId';
import { NBSP } from 'shared/constants/symbols';

import type { IAppState } from 'shared/common/state';
import type { IDiscount } from 'shared/offer';
import type { IEtazhiBlackFridayPromoOffersData } from 'shared/types/etazhiBlackFriday';

export const selectEtazhiBlackFridayDiscountByOfferId =
  (offerId: number, priceRur: number) =>
  (state: IAppState): IDiscount | null => {
    const fullPrice = selectFullPriceByOfferId(offerId)(state);

    if (!fullPrice) {
      return null;
    }

    const data = state.config.get<IEtazhiBlackFridayPromoOffersData>('proApp.etazhiBlackFridayPromoOffersData');
    const discountPercent = Math.floor(((fullPrice - priceRur) / fullPrice) * 100);

    if (data?.minDiscount && discountPercent >= data.minDiscount) {
      return {
        percent: `−${discountPercent}%`,
        newPrice: `${numberToPrettyString(priceRur)}${NBSP}₽`,
        oldPrice: `${numberToPrettyString(fullPrice)}${NBSP}₽`,
      };
    }

    return null;
  };
